import { styled } from '@/styled-system/jsx';

export const StyledSkeletonStatePage = styled('div', {
  base: {},
});

export const StyledSkeletonStatePageCards = styled('div', {
  base: {
    position: 'relative',
  },
});
